import { resolveAdminMediaUrl } from '@formosa/shared/utils/mediaUrl';

export const ADDRESS_TYPE_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'DEPOSIT', label: '充值' },
  { value: 'WITHDRAWAL', label: '提現' },
];

export const ADDRESS_TYPE_FORM_OPTIONS = [
  { value: 'DEPOSIT', label: '充值' },
  { value: 'WITHDRAWAL', label: '提現' },
];

export const STATUS_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  { value: '1', label: '啟用' },
  { value: '0', label: '禁用' },
];

export const DEFAULT_WALLET_ADDRESS_FORM = {
  addressType: 'DEPOSIT',
  cryptoCurrency: '',
  address: '',
  sort: '1',
  status: '1',
};

export function buildWalletAddressPageParams(pageNo, filters) {
  const params = { pageNo, pageSize: 15 };
  if (filters.status !== '') {
    params.status = Number(filters.status);
  }
  if (filters.addressType?.trim()) {
    params.addressType = filters.addressType.trim();
  }
  if (filters.cryptoCurrency?.trim()) {
    params.cryptoCurrency = filters.cryptoCurrency.trim();
  }
  if (filters.address?.trim()) {
    params.address = filters.address.trim();
  }
  return params;
}

export function buildCoinPayTypePageParams() {
  return { pageNo: 1, pageSize: 500 };
}

export function normalizeCoinPayTypes(records) {
  return (Array.isArray(records) ? records : [])
    .filter((item) => item?.code)
    .sort((a, b) => {
      const sortDiff = (a.sort ?? 0) - (b.sort ?? 0);
      if (sortDiff !== 0) {
        return sortDiff;
      }
      return String(a.code).localeCompare(String(b.code));
    });
}

export function findCoinByCode(coinPayTypes, code) {
  if (!code) {
    return null;
  }
  return (coinPayTypes || []).find((item) => item.code === code) || null;
}

export function getCoinOptionLabel(coin) {
  if (!coin) {
    return '';
  }
  return coin.name || coin.code;
}

export function formatAddressType(value) {
  const item = ADDRESS_TYPE_FORM_OPTIONS.find((opt) => opt.value === value)
    || ADDRESS_TYPE_FILTER_OPTIONS.find((opt) => opt.value === value);
  return item?.label || value || '—';
}

export function formatStatusLabel(status) {
  return Number(status) === 1 ? '啟用' : '禁用';
}

export function resolveImageUrl(image) {
  return resolveAdminMediaUrl(image);
}

export function rowToForm(row, coinPayTypes) {
  if (!row) {
    const firstCoin = coinPayTypes?.[0];
    return {
      ...DEFAULT_WALLET_ADDRESS_FORM,
      cryptoCurrency: firstCoin?.code || '',
    };
  }
  return {
    addressType: row.addressType ?? 'DEPOSIT',
    cryptoCurrency: row.cryptoCurrency ?? '',
    address: row.address ?? '',
    sort: row.sort != null ? String(row.sort) : '1',
    status: row.status != null ? String(row.status) : '1',
  };
}

export function formToPayload(form, editingId, coinPayTypes) {
  if (editingId != null) {
    return {
      id: editingId,
      address: form.address?.trim(),
      sort: Number(form.sort) || 0,
      status: Number(form.status) || 0,
    };
  }
  const coin = findCoinByCode(coinPayTypes, form.cryptoCurrency);
  return {
    addressType: form.addressType,
    cryptoCurrency: form.cryptoCurrency?.trim(),
    chainName: coin?.protocol?.trim() || null,
    address: form.address?.trim(),
    sort: Number(form.sort) || 0,
    status: Number(form.status) || 0,
  };
}

export function buildQrCodeUrl(value, size = 80) {
  if (!value) {
    return '';
  }
  return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(value)}`;
}
